import Vue from 'vue';
// import '@babel/polyfill';

// import Vuetify from 'vuetify/lib';
import './assets/sass/main.scss';
// import 'vuetify/dist/vuetify.min.css';

// Helpers

// import VueMaterial from 'vue-material';
// import { MdAutocomplete } from 'vue-material/dist/components';
// import 'vue-material/dist/vue-material.min.css';
// import 'vue-material/dist/theme/default.css';

// Vue.use(MdAutocomplete);
// Vue.use(VueMaterial);

import App from './App.vue';
import router from './router';
import store from './store';
// import vuetify from './plugins/vuetify';
import './registerServiceWorker';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false;

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
    // values: {}
  },
  theme: {
    // dark: true,
    themes: {
      light: {
        // primary: '#3f51b5',
        // secondary: '#b0bec5',
        // accent: '#8c9eff',
        // error: '#b71c1c'
        primary: '#ffab00',
        // primary: colors.amber.darken1,
        secondary: '#372828', // colors.amber.lighten4,
        accent: '#795548'
      }
    }
  }
  // options: {
  //   themeVariations: ['primary', 'secondary']
  // }
});

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
  // beforeCreate() {
  //   this.$store.commit('initialiseStore');
  // }
});

if (process.env.NODE_ENV !== 'production') {
  // setTimeout(() => { app.$mount('#app'); }, 500);
  app.$mount('#app');
} else {
  app.$mount('#app');
}
